import { render, staticRenderFns } from "./IconFont.vue?vue&type=template&id=1665cbd4"
import script from "./IconFont.vue?vue&type=script&lang=js"
export * from "./IconFont.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports